<template>
  <div v-if="maxPage > 1 || showEmpty">

    <!-- MOBILE (charte .wm-*). Le composant `paginate` du bureau aligne toutes les
         pages plus « Precedent » et « Suivant » : au-dela de quatre ou cinq pages
         la rangee deborde de l'ecran et devient inutilisable. Ici on montre une
         FENETRE de pages autour de la courante, avec les deux fleches. -->
    <div v-if="isMobile" class="wm-pager">
      <span class="wm-pager-info">
        Page {{ value }} sur {{ maxPage }}
      </span>
      <div class="wm-pages">
        <button class="wm-page" :disabled="value <= 1"
                :title="'Page precedente'" @click="setPage(value - 1)">
          <i class="fad fa-chevron-left"></i>
        </button>
        <button v-for="p in pageWindow" :key="'wp_' + p"
                class="wm-page" :class="{'wm-page--active': p === value}"
                @click="setPage(p)">
          {{ p }}
        </button>
        <button class="wm-page" :disabled="value >= maxPage"
                :title="'Page suivante'" @click="setPage(value + 1)">
          <i class="fad fa-chevron-right"></i>
        </button>
      </div>
    </div>

    <!-- BUREAU : inchange. -->
    <div v-else class="d-flex justify-content-between mb-5 align-items-center">
      <h4>Page {{ value }} ▪️ De {{ from }} à {{ to }} sur {{ matchCount }} </h4>
      <div :key="uKey+'_page_'+value">

        <paginate :active-class="'btn-primary text-inverse-primary'" :click-handler="setPage"
                  :container-class="'btn-group'" v-model="page" :hide-prev-next="true"
                  :next-link-class="'btn btn-sm btn-white bg-hover-primary text-hover-white'" :nextText="'Suivant'"
                  :no-li-surround="true" :page-link-class="'btn btn-sm btn-white bg-hover-primary text-hover-white'"
                  :pageCount="maxPage" :prev-link-class="'btn btn-sm btn-white bg-hover-primary text-hover-white'"
                  :prevText="'Précédent'">
        </paginate>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';
import {helper} from "@/services/Helper";
import MobileAware from "@/mixins/MobileAware";

@Component({
  // `mixins` en OPTION : `extends mixins(...)` fait perdre le typage de Vue.
  mixins: [MobileAware],
})
export default class
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  /* eslint-disable  @typescript-eslint/no-unused-vars */
  /* eslint-disable  @typescript-eslint/explicit-module-boundary-types */
Pagination extends Vue {
  // Fourni par le mixin MobileAware (declaration de type seulement).
  isMobile!: boolean;

  @Prop({default: 1}) readonly value!: number
  @Prop() count!: number;
  @Prop() matchCount!: number;
  @Prop() itemLength!: number;
  @Prop() perPage!: number;
  @Prop({default: false}) showEmpty!: boolean

  page = 1;
  uKey = helper.generateId()

  setPage(num: number): void {
    if (num < 1 || num > this.maxPage || num === this.value) {
      return
    }
    this.$emit('input', num)
  }

  mounted(): void {
    this.page = this.value
  }

  /**
   * Fenetre de pages affichees sur mobile : cinq au plus, centrees sur la page
   * courante et recalees aux bords. Tout afficher deborderait de l'ecran des la
   * sixieme page ; n'afficher que la courante priverait du saut direct.
   */
  get pageWindow(): number[] {
    const size = 5
    const max = this.maxPage
    if (max <= size) {
      return Array.from({length: max}, (_, i) => i + 1)
    }
    let start = this.value - Math.floor(size / 2)
    if (start < 1) start = 1
    if (start + size - 1 > max) start = max - size + 1
    return Array.from({length: size}, (_, i) => start + i)
  }

  get from(): number {
    return this.matchCount > 0 ? ((this.value - 1) * this.perPage) + 1 : 0;
  }

  get maxPage(): number {
    const max = this.matchCount > 0 ? Math.ceil(this.matchCount / this.perPage) : 1;
    if (this.value > max) {
      this.$emit('input', max)
    }
    return max;
  }

  get to(): number {
    if(this.matchCount <=0){
      return 0
    }
    let val = this.from + this.itemLength - 1
    if(this.matchCount < val){
      val = this.matchCount
    }
    return val;
  }
}
</script>
<style scoped>
/* Le pager mobile vit dans une carte de liste : il en reprend la surface, sinon
   il flotte sur le fond gris de l'ecran. */
.wm-pager {
  background: var(--wm-surface);
  border-top: 1px solid var(--wm-hairline);
}
</style>
